module.exports = __webpack_public_path__ + "static/media/shen_headshot.b748b671.jpeg";